import { useContext } from "react";
import { Helmet } from "react-helmet";
import UpperbarContext from "../context/upperbar-context";

export default function URLpreview({ description, title, img }) {
  const { url } = useContext(UpperbarContext);


  return (
    <div>
      <Helmet>
        <meta property="og:title" content={title} />
        <meta property="og:image" content={img} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={url} />
      </Helmet>
    </div>
  );
}
